import fondoUrl from "../../assets/images/fondo.png";
import styles from "./AppBackground.module.css";

function AppBackground() {
  return (
    <img
      className={styles.appBackground}
      alt=""
      aria-hidden="true"
      src={fondoUrl}
      decoding="async"
      draggable={false}
    />
  );
}

export default AppBackground;
